module.exports = ".font-weight {\n  font-weight: 400; }\n"